// Asistent v hlavičce — od rozhodnutí 05/1520 (2. 10. 2026, postaveno W24) nemá vlastní tlačítko: ptá se se v jednom
// poli s hledáním (`shell/Hledani.tsx`, Ctrl+K i „/“). Tady zůstává jen to, co se musí vykreslit v hlavičce vždy:
//   * panel asistenta (`PanelAsistenta.tsx`) — těžký, takže se stáhne až při prvním otevření (`lina()`, docs/09 §12,
//     rozpočet hlavního balíku ve `vite.config.ts`) a pak zůstane připojený, aby panel držel rozepsanou konverzaci;
//   * tlačítko „Zařadit odpad“ pro účty bez obecného asistenta (řidič, skladník, mlynář).
import type { Ja } from '@ecoser/shared';
import { useEffect, useState } from 'react';
import { AKCE_ZARADIT } from '../api/zarazeni-odpadu';
import { lina, NacitaniCasti } from '../komponenty/NacitaniCasti';
import { maAkci } from '../komponenty/prava';
import { usePanelAsistenta } from './panel-stav';
import { smiAsistenta } from './pravo-asistenta';
import { ZnackaAsistenta } from './ZnackaAsistenta';
import './asistent-hlavicka.css';

const PanelAsistenta = lina(() => import('./PanelAsistenta').then((m) => m.PanelAsistenta));

// Poradce zařazení odpadu se stahuje až po otevření (docs/09 §10 — nic těžkého do shellu).
const PoradceZarazeni = lina(() =>
  import('./poradce-zarazeni/PoradceZarazeni').then((m) => m.PoradceZarazeni),
);

/** Panel se připojí při prvním otevření (odkudkoli: pole hledání, centrum asistenta, příklad) a už zůstane. */
function PanelPoPrvnimOtevreni({ ja }: { ja: Ja }) {
  const { otevreny } = usePanelAsistenta();
  const [bylOtevreny, setBylOtevreny] = useState(otevreny);
  useEffect(() => {
    if (otevreny) setBylOtevreny(true);
  }, [otevreny]);
  if (!otevreny && !bylOtevreny) return null;
  return (
    <div className="asistent-nacitani">
      <NacitaniCasti text="Načítám asistenta…">
        <PanelAsistenta ja={ja} />
      </NacitaniCasti>
    </div>
  );
}

export function AsistentVHlavicce({ ja }: { ja: Ja }) {
  if (smiAsistenta(ja)) return <PanelPoPrvnimOtevreni ja={ja} />;
  return maAkci(ja.akce, AKCE_ZARADIT) ? <PoradceVHlavicce /> : null;
}

/**
 * Poradce zařazení odpadu v hlavičce — pro účty bez obecného asistenta (řidič, skladník, mlynář; rozhodnutí zadavatele
 * 4. 10. 2026): jen rada bez zakázky, položku přidají u jízdy (Můj den › Odpady má vlastní tlačítko s předvyplněním).
 */
function PoradceVHlavicce() {
  const [otevreno, setOtevreno] = useState(false);
  return (
    <>
      <button
        type="button"
        className="hlavicka__asistent"
        aria-haspopup="dialog"
        aria-expanded={otevreno}
        title="Poradce zařazení odpadu — vyfoťte nebo popište odpad a asistent navrhne kód"
        onClick={() => setOtevreno(true)}
        data-testid="hlavicka-poradce"
      >
        <ZnackaAsistenta velikost={15} />
        <span className="hlavicka__asistent-text">Zařadit odpad</span>
      </button>
      {otevreno && (
        <NacitaniCasti text="Načítám poradce zařazení…">
          <PoradceZarazeni naZavrit={() => setOtevreno(false)} />
        </NacitaniCasti>
      )}
    </>
  );
}
